/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VerifyKYCStepTwoParam { 
    /**
     * Face of the user that is to be verified. Must be a .jpeg
     */
    facePhotoSelfie: string;
    /**
     * Face of the user that is to be verified. Optionally used for performing extra alive-ness checks. Must be a .jpeg
     */
    facePhotoSelfieAlive?: string;
    /**
     * Video evidence of the user that is to be verified. Only required for some challenges, supercedes facePhotoSelfieAlive if used. Must be an .mp4
     */
    faceVideoSelfie?: string;
    /**
     * Video annotations for the faceVideoSelfie file. Only required for some challenges. Must be a .vtt
     */
    faceVideoSelfieAnnotations?: string;
}

